$(document).ready(function($) {
  var initLocations, initMarkers, map, moveMap;

  $('#address-lookup .custom-control-input').on('change', function() {
    $('#address-lookup').submit();
  });
  
  initLocations = function(lat, lon) {
    var point, specialty;
    point = void 0;
    specialty = "0";
    if (typeof lat !== 'undefined' && typeof lon !== 'undefined') {
      point = {
        lat: lat,
        lon: lon
      };
    }
    specialty = $("input[name='specialty']:checked").val();
    return $.getJSON('/api/dealer_locations/' + specialty, point, function(data) {
      var html, tmpl;
      tmpl = window.jQuery.templates("#dealerTemplate");
      html = '';
      $.each(data.data, function(k, v) {
        return html += tmpl.render(v);
      });
      if (typeof $dealerGrid !== 'undefined') {
        $("#dealers").find('.dealer').remove();
      }
      $('#dealers').html(html);
    });
  };

  initMarkers = function() {
    var specialty, url;
    specialty = $("input[name='specialty']:checked").val();
    url = '/api/map_markers/' + specialty;
    return map.getSource('dealers').setData(url);
  };

  moveMap = function(lat, lon) {
    map.flyTo({
      center: [lon, lat],
      zoom: 10
    });
    return initLocations(lat, lon);
  };

  $('#address-lookup').submit(function(event) {
    var address;
    address = $("#address").val();
    $.getJSON('/api/locations/' + encodeURI(address), function(data) {
      moveMap(data.lat, data.lon);
      return initMarkers('1');
    });
    return false;
  });

  if ($('#map').get(0)) {
    mapboxgl.accessToken = 'pk.eyJ1IjoibWVzaGJyYWlucyIsImEiOiJjam94NXFxb20xbmpoM3ZzNWppZndxOWpxIn0.JV3G4LG9niWgIA1VjGv38A';
    map = new mapboxgl.Map({
      container: 'map',
      center: [-118.2437, 34.0522],
      zoom: 4,
      style: 'mapbox://styles/mapbox/light-v9'
    });
    map.on('load', function(e) {
      map.loadImage('/images/map_marker.png', function(error, image) {
        if (error) {
          throw error;
        }
        map.addImage('custom-marker', image);
        map.addSource('dealers', {
          type: 'geojson',
          data: '/api/map_markers'
        });
        map.addLayer({
          id: 'dealers_layer',
          type: 'symbol',
          source: 'dealers',
          layout: {
            'icon-image': 'custom-marker',
            'icon-allow-overlap': true
          }
        });
      });
    });

    map.on('click', 'dealers_layer', function(e) {
      var coordinates, description;
      coordinates = e.features[0].geometry.coordinates.slice();
      description = e.features[0].properties.description;
      while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
        coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
      }
      (new mapboxgl.Popup).setLngLat(coordinates).setHTML(description).addTo(map);
    });

    map.on('mouseenter', 'dealers_layer', function() {
      map.getCanvas().style.cursor = 'pointer';
    });

    map.on('mouseleave', 'dealers_layer', function() {
      map.getCanvas().style.cursor = '';
    });

    $.getJSON('/api/locations', function(data) {
      return moveMap(data.lat, data.lon);
    });
  }
});